<template>
    <AccordionItem :id="id">
        <slot />
    </AccordionItem>
</template>

<script setup>
    import { inject, onBeforeMount, onUnmounted } from 'vue'
    import AccordionItem from '@app/components/accordion/Refactored/AccordionItem.vue'

    const props = defineProps({
        id    : String,
        title : String
    })

    const { addTab, removeTab } = inject('tabs')

    onBeforeMount(() => addTab(props.id, props.title))
    onUnmounted(() => removeTab(props.id))
</script>